export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL =
  "https://cdn4.iconfinder.com/data/icons/volunteering/128/food-sharing-giving-receiving-512.png";
//https://corsproxy.io/?https://www.swiggy.com/dapi/menu/v4/full?lat=12.9351929&lng=77.62448069999999&menuId=
//

export const RES_MENU_API =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.945474&lng=77.584456&restaurantId=";
export const RESTAURANTS_API =
  "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9351929&lng=77.62448069999999&page_type=DESKTOP_WEB_LISTING";
  //https://corsproxy.io/?
export const IMAGE="https://t3.ftcdn.net/jpg/06/24/02/34/360_F_624023407_XM2NTuOBVZoiq3t7DhB6qVa7Ai3ZWZyn.jpg"
export const RESTAURANT="https://static.vecteezy.com/system/resources/previews/040/181/420/non_2x/restaurant-facade-background-banner-in-flat-cartoon-design-street-cafeteria-exterior-poster-with-table-and-chairs-on-terrace-menu-showcase-and-entrance-garlands-on-trees-illustration-vector.jpg"
export const PHARMACY="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQz9ZzW-bTRecOLm_cq68j0lE8En5MeeYiBZuIGZ_k3Wj_FK6PAi0ipmEyHwDilVLXaTG4&usqp=CAU.jpg"
export const DEVELOPER="https://avatars.githubusercontent.com/u/98137553?s=400&u=31371930fc9338173fabf94d38095bdeedf2646d&v=4.jpg"